module.exports = __webpack_public_path__ + "static/media/landscape-cropx4.235209da.webp";